import { Map } from "immutable";

function getPaths(callback, onError) {
  fetch('https://s3.amazonaws.com/exercise.whyyoushouldstoptesting.com/')
  .then(response => {
    return response.text();
  }).then(text => {
    let parser = new DOMParser();
    let dom = parser.parseFromString(text,"text/xml");
    let keys = Array.from(dom.getElementsByTagName("Key")).map(keyElement => {
      return keyElement.childNodes[0].nodeValue;
    });
  
    let paths = Map();
    keys.forEach(key => {
      let parts = key.split("/").filter(element => element !== "");
      if (parts.length === 1) {
        paths = paths.set(parts[0], {
          id: parts[0]
        });
      }
      if (parts.length === 3) {
        let value = paths.get(parts[0]);
        if (value == null) {
          value = {
            id: parts[0]
          };
          paths = paths.set(parts[0], value);
        }
        if (parts[1] === "default") {
          if (value.files == null) {
            value.files = [];
          }
          value.files.push(parts[2]);
        } else {
          if (value.changes == null) {
            value.changes = Map();
          }
          let group = value.changes.get(parts[1]);
          if (group == null) {
            group = [];
          }
          group.push(parts[2]);
          value.changes = value.changes.set(parts[1], group);
        }
      }
    });
    callback(paths);
  }).catch(error => {
    onError(error);
  });
}

function getContent(files, id, group, callback, onError) {
  Array.from(files.keys()).filter(file => file.endsWith(".js")).forEach(file => {
    fetch('https://s3.amazonaws.com/exercise.whyyoushouldstoptesting.com/'+id+'/'+group+'/'+file)
      .then(response => {
        return response.text();
      }).then(text => {
        files = files.set(file, text);
        callback(files);
      }).catch(error => {
        onError(error);
      });
  });
}

function getMetadata(id, group, callback, onError) {
  fetch('https://s3.amazonaws.com/exercise.whyyoushouldstoptesting.com/'+id+'/'+group+'/metadata.json')
    .then(response => {
      return response.json();
    }).then(json => {
      callback(json);
    }).catch(error => {
      onError(error);
  });
}

export default {getPaths, getContent, getMetadata};


// WEBPACK FOOTER //
// ./src/api/ExerciseApi.js